import React, {Component} from 'react';
import classNames from 'classnames';
import styles from './Page.less';

class Page extends Component {
	render() {
		const {header, footer, children} = this.props;
		const {
			'page__wrapper': wrapperClass
		} = styles;
		const ui_version = window.shop_productgroup.ui_version;

		return (
			<div>
				{header}
				<div className={classNames(ui_version === '2.0' ? 'custom-mb-32' : wrapperClass)}>
					{children}
				</div>
				{footer}
			</div>
		);
	}
}

export default Page;